import { SelectOptionType, Icon, Select } from "@aidkitorg/component-library"
import { SupportedLanguage } from "@aidkitorg/i18n/lib"
import React, { useContext } from "react"
import InterfaceContext from "../../Context"
import { langToWord, useLocalizedStrings } from "../../Localization"

type LanguageDropdownProps = {
  languages: Array<SupportedLanguage>,
  /**
   * If true, the dropdown will not be rendered in a portal.
   * This is useful when the dropdown is used in a modal or a popup
   * where you may encounter conflicts with other portals.
   */
  skipPortal?: boolean
}

export const LanguageDropdown: React.FC<LanguageDropdownProps> = React.memo(({ languages, skipPortal = false }) => {
  const interfaceContext = useContext(InterfaceContext);
  const L = useLocalizedStrings();

  const languageOptions: Array<SelectOptionType> = []
  languages.forEach((l) => {
    languageOptions.push({
      value: l as string,
      label: langToWord(l)
    })
  })

  const selected = languageOptions.find(option => option.value === interfaceContext.lang) || languageOptions[0]

  return (
    <Select
      label={<Icon role="decorative" type="solid" name="LanguageIcon" />}
      labelLocation='inline'
      description={L.admin_panel.language_dropdown.select_a_language}
      options={languageOptions}
      value={selected}
      anchor={skipPortal ? null as any : undefined}
      onChange={(value) => {
        interfaceContext.setLanguage(value.value as SupportedLanguage)
      }}
    />
  )
})